import { render, staticRenderFns } from "./CategorySetting.vue?vue&type=template&id=3bd543d1&scoped=true&"
import script from "./CategorySetting.vue?vue&type=script&lang=js&"
export * from "./CategorySetting.vue?vue&type=script&lang=js&"
import style0 from "./CategorySetting.vue?vue&type=style&index=0&id=3bd543d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd543d1",
  null
  
)

export default component.exports